import { NFSE_STATUS_LABEL, NfseStatus } from "./nfse-status.enum";
import { TomadorModel } from "./tomador.model";

export type NfseCampoCorrigivel =
  | "razaoSocialOuNome"
  | "cpfCnpj"
  | "email"
  | "endereco"
  | "discriminacaoServico";

export const NFSE_CAMPOS_CORRIGIVEIS_PADRAO: NfseCampoCorrigivel[] = [
  "cpfCnpj",
  "email",
  "endereco",
  "discriminacaoServico",
];

/** POST nfse/list — item da listagem (contrato real). */
export interface NfseInvoiceListModel {
  id: string;
  idInspection: string;
  idEcv: string;
  numeroOS?: string | null;
  idNfseInvoiceStatus: number;
  status: NfseStatus | string;
  statusDescricao?: string | null;
  numero?: string | null;
  serie?: string | null;
  issuedAt?: string | null;
  authorizedAt?: string | null;
  resolvedAt?: string | null;
  createdAt?: string | null;
  serviceValue?: number | null;
  rejectionMessage?: string | null;
}

export interface NfseInvoiceModel {
  idNfseInvoice: string;
  idInspection: string;
  idEcv: string;
  status: NfseStatus;
  numero: string | null;
  serie: string | null;
  codigoVerificacao: string | null;
  protocolo: string | null;
  dataAbertura: string | null;
  dataEmissao: string | null;
  serviceOrder: string | null;
  placa: string | null;
  valorServico: number;
  tomador: TomadorModel;
  discriminacaoServico: string | null;
  mensagemRejeicao: string | null;
  camposCorrigiveis: NfseCampoCorrigivel[] | null;
  dataCancelamento: string | null;
  motivoCancelamento: string | null;
  linkNota: string | null;
  documentosDisponiveis: {
    xmlDisponivel: boolean;
    pdfDisponivel: boolean;
  };
}

export interface NfseInvoiceNotFound {
  /** @deprecated API usa possuiNfse — preferir NfseInvoiceSituationModel + isSemNota */
  existe: false;
  status: NfseStatus;
  motivoInelegibilidade: string | null;
}

/** @deprecated Use isSemNota de nfse-invoice-situation.model */
export function isNfseInvoiceNotFound(
  res: { possuiNfse?: boolean; existe?: false }
): boolean {
  if (res.possuiNfse === false) {
    return true;
  }
  return (res as NfseInvoiceNotFound)?.existe === false;
}

/** GET nfse/historico/{idInspection} */
export interface NfseInvoiceEventModel {
  dataHora: string;
  tipoEvento: string;
  descricaoEvento?: string | null;
  statusAnterior?: string | null;
  statusNovo?: string | null;
  responsavel: string;
  retornoProvedor?: string | null;
  statusBrutoProvedor?: string | null;
}

export function ordenarHistoricoNfse<T extends { dataHora?: string }>(
  eventos: T[]
): T[] {
  return [...eventos].sort((a, b) => {
    const ta = new Date(a.dataHora).getTime();
    const tb = new Date(b.dataHora).getTime();
    if (Number.isNaN(ta) || Number.isNaN(tb)) {
      return 0;
    }
    return ta - tb;
  });
}

export function transicaoStatusHistorico(evento: {
  statusAnterior?: string | null;
  statusNovo?: string | null;
}): string {
  const anterior = rotuloStatusEvento(evento.statusAnterior);
  const novo = rotuloStatusEvento(evento.statusNovo);
  if (anterior === "-" && novo === "-") {
    return "-";
  }
  if (anterior === novo) {
    return anterior;
  }
  return `${anterior} → ${novo}`;
}

export function textoRetornoProvedor(evento: NfseInvoiceEventModel): string {
  const partes = [evento.retornoProvedor, evento.statusBrutoProvedor]
    .map((valor) => (valor || "").trim())
    .filter(Boolean);
  return partes.length ? partes.join(" — ") : "-";
}

function rotuloStatusEvento(status?: string | null): string {
  if (!status) {
    return "-";
  }
  return NFSE_STATUS_LABEL[status as NfseStatus] || status;
}
